module.exports = __webpack_public_path__ + "img/UTFREM-2.d977ba85.jpg";